import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const depression = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
